import React, { useEffect, useState } from "react";
import Loader from "../../components/common/loader";
import {
  Card,
  CardBody,
  Col,
  Container,
  Form,
  FormFeedback,
  Input,
  Label,
  Row,
} from "reactstrap";
import BreadCrumb from "../../components/common/breadCrumb";
import { Link, useNavigate, useParams } from "react-router-dom";
import Flatpickr from "react-flatpickr";
import * as Yup from "yup";
import { useFormik } from "formik";
import { InputPlaceHolder, SelectPlaceHolder, validationMessages } from "../../utils/helpers/validationMasseges";
import { DailyTakStatus, Hours, MinutesOption, ResponseStatusEnum, TaskStatus } from "../../utils/helpers/enums";
import { toast } from "react-toastify";
import {
  addTasksheet,
  editTaskSheet,
  listOfTimesheet,
  listOfAssignProjects,
  listOfTasks,
} from "../../api/tasksheetApi";
import { getId } from "../../utils/helpers/custom";
import Select from "react-select";
import { TIME_ZERO } from "../../utils/helpers/enums";
import { checkStatusCodeSuccess, CommonLabel } from "../../utils/helpers/common";
import { TaskLabel } from "../../common/constant/Task";
import { BaseSelect } from "../../components/BaseComponents/BaseSelect";
import BaseButton from "../../components/BaseComponents/BaseButton";
import BaseInput from "../../components/BaseComponents/BaseInput";

const TimesheetAddEdit = () => {
  const { timesheet_id } = useParams();
  const [loading, setLoading] = useState(false);
  const [btnLoader, setBtnLoader] = useState(false);
  const [pageTitle, setPageTitle] = useState();
  const [isEdited, setIsEdit] = useState();
  const [editTimeSheetData, setEditTimeSheetData] = useState();
  const [listOfProject, setListOfProject] = useState([]);
  const [task, setTask] = useState(null);
  const [listOfTask, setlistOfTask] = useState([]);
  const [selectedProject, setSelectedProject] = useState();
  const [selectedTask, setSelectedTask] = useState(null);
  const [selectedTaskStatus, setSelectedTaskStatus] = useState(null);
  const [selectedDailyTaskStatus, setSelectedDailyTaskStatus] = useState(null);
  const [selectedRemainTime, setSelectedRemainTime] = useState(null);
  let storeRemainTime;
  const isEdit = null;

  const id = getId();
  const navigate = useNavigate();


  document.title = pageTitle;
  const [projectSelected, setProjectSelected] = useState(false);
  const [loadingTasks, setLoadingTasks] = useState(false);

  useEffect(() => {
    if (!isNaN(timesheet_id)) {
      setIsEdit(true);
      setPageTitle(TaskLabel.EditTimesheet);
      setLoading(true);
      listOfTimesheet({
          timeSheetId: timesheet_id,
      })
        .then((res) => {
          setEditTimeSheetData(res?.data?.data?.listOfTaskSheet[0]);
          setSelectedProject({
            value: res?.data?.data?.listOfTaskSheet[0]?.taskSheet?.projectName,
            label: res?.data?.data?.listOfTaskSheet[0]?.taskSheet?.projectName,
          });
          setSelectedTask({
            value: res?.data?.data?.listOfTaskSheet[0]?.taskSheet?.taskName,
            label: res?.data?.data?.listOfTaskSheet[0]?.taskSheet?.taskName,
          });
          setSelectedTaskStatus({
            value: res?.data?.data?.listOfTaskSheet[0]?.taskStatus,
            label: res?.data?.data?.listOfTaskSheet[0]?.taskStatus,
          });
          setSelectedDailyTaskStatus({
            value: res?.data?.data?.listOfTaskSheet[0]?.dailyStatus,
            label: res?.data?.data?.listOfTaskSheet[0]?.dailyStatus,
          });
          setSelectedRemainTime(res?.data?.data?.listOfTaskSheet[0]?.taskSheet?.remainingTime);
          setLoading(false);
        })
        .catch((err) => setLoading(false));
    } else {
      setIsEdit(false);
      setPageTitle(TaskLabel.AddTimesheet);
    }

    listOfAssignProjects()
      .then((res) => {
        setListOfProject(res?.data?.data?.map((res) => ({
          value: res?.project?.projectName,
          label: res?.project?.projectName,
        })))
      })
      .catch((err) => setLoading(false));

    listOfTimesheet({
      modelName: "taskSheetModel",
      condition: {
        id: timesheet_id,
      },
    });
  }, [timesheet_id]);

  useEffect(() => {
    if (selectedProject) {
      setProjectSelected(true);
    } else {
      setProjectSelected(false);
    }
  }, [selectedProject]);

  useEffect(() => {
    if (projectSelected) {
      let projectName = selectedProject;
      setLoadingTasks(true);
      listOfTasks({
        assignTo: parseInt(id),
        projectName,
        taskStatus: CommonLabel.Pending,
      })
        .then((res) => {
          setlistOfTask(res?.data?.data?.map((res) =>
          ({
              value: res?.id,
              label: res?.taskName,
              estimateTime: res?.estimateTime,
              remainingTime: res?.remainingTime,
          })))
        })
        .catch((err) => {
          setlistOfTask([]);
          return err;
        })
        .finally(() => setLoadingTasks(false));
    }
  }, [projectSelected, selectedProject, id]);

  const validation = useFormik({
    enableReinitialize: true,

    initialValues: {
      projectTask: editTimeSheetData?.taskSheet?.projectName || "",
      taskSheetId: editTimeSheetData?.taskSheetId || "",
      date: editTimeSheetData?.date || "",
      takenHours: Number(editTimeSheetData?.takenHours) || "",
      takenMinutes: editTimeSheetData?.takenMinutes || "",
      detailsOfTask: editTimeSheetData?.detailsOfTask || "",
      taskStatus: editTimeSheetData?.taskStatus || "",
      dailyStatus: editTimeSheetData?.dailyStatus || "",
    },
    validationSchema: Yup.object({
      projectTask: Yup.string().required(validationMessages.required(TaskLabel.ProjectName)),
      taskSheetId: Yup.string().required(validationMessages.required(TaskLabel.Task)),
      date: Yup.string().required(validationMessages.required(TaskLabel.Date)),
      takenMinutes: Yup.string().optional(),
      takenHours: Yup.string().optional(),
      detailsOfTask: Yup.string().required(validationMessages.required(TaskLabel.TaskDetail)),
      taskStatus: Yup.string().required(validationMessages.required(TaskLabel.TaskStatus)),
      dailyStatus: Yup.string().required(validationMessages.required(TaskLabel.DailyStatus)),
    }),
    onSubmit: (value) => {
      setBtnLoader(true);
      if (isEdited) {
        editTaskSheet({
          userId: id,
          id: parseInt(timesheet_id),
          projectTask: value?.projectTask,
          taskSheetId: value?.taskSheetId,
          detailsOfTask: value?.detailsOfTask,
          date: value?.date,
          taskStatus: value?.taskStatus,
          takenHours: +value?.takenHours,
          takenMinutes: +value?.takenMinutes,
          dailyStatus: value?.dailyStatus,
        })
          .then((res) => {
            if (checkStatusCodeSuccess(res?.data?.statusCode)) {
              toast.success(res?.data?.message);
              validation.resetForm();
              navigate("/timesheet");
            } else {
              toast.error(res?.data?.message);
            }
          })
          .finally(() => setBtnLoader(false));
      } else {
        addTasksheet({
          userId: id,
          projectTask: value?.projectTask,
          taskSheetId: value?.taskSheetId,
          detailsOfTask: value?.detailsOfTask,
          date: value?.date,
          takenMinutes: +value?.takenMinutes,
          takenHours: +value?.takenHours,
          taskStatus: value?.taskStatus,
          dailyStatus: value?.dailyStatus,
          remainingTime: storeRemainTime
        })
          .then((res) => {
            if (checkStatusCodeSuccess(res?.data?.statusCode)) {
              toast.success(res?.data?.message);
              validation.resetForm();
              navigate("/timesheet");
            } else {
              toast.error(res?.data?.message);
            }
          })
          .finally(() => setBtnLoader(false));
      }
    },
  });

  function timeStringToSeconds(timeString) {
    if (!timeString || timeString.split(":").length !== 3) {
      return undefined;
    }

    let [hours, minutes, seconds] = timeString.split(":").map(Number);
    if (isNaN(hours) || isNaN(minutes) || isNaN(seconds)) {
      return undefined;
    }

    return hours * 3600 + minutes * 60 + seconds;
  }
  let selectedHours = validation?.values?.takenHours;
  let selectedTakenMinutes = validation?.values?.takenMinutes;

  let totalSeconds = timeStringToSeconds(isEdited ? selectedRemainTime : task?.remainingTime);
  let inputSeconds = selectedHours * 3600 + selectedTakenMinutes * 60;
  let remainingSeconds = totalSeconds - inputSeconds;
  
  let remainingHour = Math.floor(remainingSeconds / 3600);
  let remainingMinutes = Math.floor((remainingSeconds % 3600) / 60);
  let remainingSecondsOutput = remainingSeconds % 60;
  
  const finalTime = (hr, min, sec) => {
    if (hr < 0 || min < 0) {
      return TIME_ZERO;
    } else {
      let finalHr = (hr === 0) ? "00" : (String(hr).length === 1) ? `0${hr}`: hr;
      let finalMin = (min === 0) ? "00" : min;
      const reamingTime = `${finalHr}:${finalMin}:${sec}0`;
      return reamingTime;
    }
  };

  storeRemainTime = finalTime(
    remainingHour,
    remainingMinutes,
    remainingSecondsOutput
  );

  return (
    <div className="page-content">
      {loading ? (
        <Loader />
      ) : (
        <Container fluid>
          <BreadCrumb title={pageTitle} pageTitle="HRMS" />
          <Row className="mb-2">
            <div className="col-sm order-3 order-sm-2 mt-3 mt-sm-0">
              <h5 className="fw-semibold mt-2">{pageTitle}</h5>
            </div>
            <div className="col-auto order-2 order-sm-3 ms-auto">
              <div className="hstack gap-2">
                <Link to={"/timesheet"} className="btn btn-primary">
                  {CommonLabel.Back}
                </Link>
              </div>
            </div>
          </Row>
          <Card>
            <CardBody>
              <Form onSubmit={validation.handleSubmit}>
                <Row>
                  <Col lg={6}>
                    <div className="mb-3">
                      <BaseSelect
                        name="projectTask"
                        placeholder={SelectPlaceHolder(TaskLabel.ProjectName)}
                        label={TaskLabel.ProjectName}
                        options={listOfProject}
                        value={validation?.values?.projectTask}
                        handleChange={(field, value) => {
                          setSelectedProject(value);
                          validation.setFieldValue(field, value);
                          setSelectedTask("");
                        }}
                        handleBlur={validation.handleBlur}
                        touched={validation.touched.projectTask}
                        error={validation.errors.projectTask}
                        required={true}
                      />
                    </div>
                  </Col>

                  <Col lg={6}>
                    <div className="mb-3">
                      <BaseSelect
                        name="taskSheetId"
                        placeholder={SelectPlaceHolder(TaskLabel.Task)}
                        label={TaskLabel.Task}
                        options={listOfTask}
                        value={validation?.values?.taskSheetId}
                        handleChange={(field, value) => {
                          setSelectedTask(value);
                          const taskDetail = listOfTask.find((item) => item?.value === value)
                          setTask(taskDetail);
                          validation.setFieldValue(field, value);
                        }}
                        handleBlur={validation.handleBlur}
                        touched={validation.touched.taskSheetId}
                        error={validation.errors.taskSheetId}
                        required={true}
                      />
                    </div>
                  </Col>

                  <Col lg={6}>
                    <div className="mb-3">
                      <label
                        htmlFor="task-duedate-input"
                        className="form-label"
                      >
                        Date :
                      </label>
                      <Flatpickr
                        name="date"
                        id="date-field"
                        onBlur={validation.handleBlur}
                        className={`form-select  ${
                          validation.errors.date && validation.touched.date
                            ? "is-invalid"
                            : null
                        }`}
                        placeholder="Enter Date Time"
                        value={validation.values.date}
                        options={{
                          altInput: true,
                          altFormat: "F j, Y",
                          dateFormat: "Y-m-d",
                          onChange: function (
                            selectedDates,
                            dateStr,
                            instance
                          ) {
                            validation.setFieldValue("date", dateStr);
                          },
                        }}
                      />
                      {validation.touched.date && validation.errors.date ? (
                        <div className="invalid-feedback">
                          {validation.errors.date}
                        </div>
                      ) : null}
                    </div>
                  </Col>
                  <Col lg={6}>
                    <div className="mb-3">
                      <label htmlFor="task-hour-input" className="form-label">
                        {TaskLabel.TakenTime} :
                      </label>
                        <div className="input-group">
                          <div className="input-group">
                        <select
                          name="takenHours"
                          id="task-hour-input"
                          className={`form-control ${
                            validation.errors.takenHours &&
                            validation.touched.takenHours
                              ? "is-invalid"
                              : ""
                          }`}
                          value={validation?.values?.takenHours || ""}
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          invalid={
                            !!(
                              validation.touched.takenHours &&
                              validation.errors.takenHours
                            )
                          }
                          >
                          <option value="00" selected hidden>{SelectPlaceHolder(TaskLabel.Hour)}</option>
                          {Hours.map((hour) => (
                            <option key={hour?.value} value={hour?.value}>
                              {hour?.label}
                            </option>
                          ))}
                        </select>
                        {validation.touched.takenHours &&
                        validation.errors.takenHours ? (
                          <FormFeedback type="invalid">
                            {validation.errors.takenHours}
                          </FormFeedback>
                        ) : null}
                        <span className="input-group-text">:</span>
                        <select
                          name="takenMinutes"
                          id="task-minute-input"
                          className={`form-control ${
                            validation.errors.takenMinutes &&
                            validation.touched.takenMinutes
                              ? "is-invalid"
                              : ""
                          }`}
                          value={validation?.values?.takenMinutes || ""}
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}>
                          <option value="00" hidden selected>{SelectPlaceHolder(TaskLabel.Minutes)}</option>
                          {MinutesOption?.map((minute) => (
                            <option key={minute?.value} value={minute?.value}>
                              {minute?.label}
                            </option>
                          ))}
                        </select>
                        {validation.touched.takenHours &&
                        validation.errors.takenHours ? (
                          <FormFeedback type="invalid">
                            {validation.errors.takenHours}
                          </FormFeedback>
                        ) : null}
                      </div>
                      </div>
                    </div>
                  </Col>
                  <Col lg={6}>
                    <div className="mb-3">
                      <BaseInput
                        name="detailsOfTask"
                        type="textarea"
                        placeholder={InputPlaceHolder(TaskLabel.TaskDetail)}
                        label={TaskLabel.TaskDetail}
                        onChange={validation.handleChange}
                        handleBlur={validation.handleBlur}
                        value={validation?.values?.detailsOfTask}
                        touched={validation.touched.detailsOfTask}
                        error={validation.errors.detailsOfTask}
                        required={true}
                      />
                    </div>
                  </Col>
                  <Col lg={6}>
                    <Row>
                      <Col lg={6}>
                        <div className="mb-3">
                          <BaseSelect
                            name="taskStatus"
                            placeholder={SelectPlaceHolder(
                              TaskLabel.TaskStatus
                            )}
                            label={TaskLabel.TaskStatus}
                            options={TaskStatus}
                            value={validation?.values?.taskStatus}
                            handleChange={(field, value) => {
                              validation.setFieldValue(field, value);
                              setSelectedTaskStatus(value);
                            }}
                            handleBlur={validation.handleBlur}
                            touched={validation.touched.taskStatus}
                            error={validation.errors.taskStatus}
                            required={true}
                          />
                        </div>
                      </Col>
                      <Col lg={6}>
                        <div className="mb-3">
                          <BaseSelect
                            name="dailyStatus"
                            placeholder={SelectPlaceHolder(
                              TaskLabel.DailyStatus
                            )}
                            label={TaskLabel.DailyStatus}
                            options={DailyTakStatus}
                            value={validation?.values?.dailyStatus}
                            handleChange={(field, value) => {
                              validation.setFieldValue(field, value);
                              setSelectedTaskStatus(value);
                            }}
                            handleBlur={validation.handleBlur}
                            touched={validation.touched.dailyStatus}
                            error={validation.errors.dailyStatus}
                            required={true}
                          />
                        </div>
                      </Col>
                      <Col lg={12}>
                        <p className="mt-3">
                          {selectedTask &&
                            (isEdited ? (
                              <>
                                {TaskLabel.EstimateTime}:
                                {selectedRemainTime !== undefined
                                  ? selectedRemainTime
                                  : TIME_ZERO}
                                <br />
                                {TaskLabel.RemainingTime}:
                                {finalTime(
                                  remainingHour,
                                  remainingMinutes,
                                  remainingSecondsOutput
                                )}
                              </>
                            ) : (
                              <>
                                {TaskLabel.EstimateTime}:
                                {selectedTask?.estimateTime !== undefined
                                  ? selectedTask?.remainingTime
                                  : TIME_ZERO}
                                <br />
                                {TaskLabel.RemainingTime}:
                                {finalTime(
                                  remainingHour,
                                  remainingMinutes,
                                  remainingSecondsOutput
                                )}
                              </>
                            ))}
                        </p>
                      </Col>
                    </Row>
                    <Row></Row>
                  </Col>
                  <Col lg={12}>
                    <div className="hstack gap-2 justify-content-end">
                      <BaseButton type="submit" color="primary" loader={btnLoader}>
                        {isEdited ? CommonLabel.Update : CommonLabel.Submit}
                      </BaseButton>
                    </div>
                  </Col>
                </Row>
              </Form>
            </CardBody>
          </Card>
        </Container>
      )}
    </div>
  );
};

export default TimesheetAddEdit;
